// extracted by mini-css-extract-plugin
export default {"working":"Working_working__hmYOe","design1":"Working_design1__ec9+E","swiggle1":"Working_swiggle1__ujuB6","swiggle2":"Working_swiggle2__nUPqh","design2":"Working_design2__Yul9m"};